
//  Slider
$( document ).ready( function() {
  const $html = $(document.documentElement);
  $( '.gift-slider' ).each( function() {
      $( this ).slick( {
        arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          touchThreshold: 0,
          
            prevArrow: '<div class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0435/7308/4325/t/59/assets/arrow-prev.svg?v=1668618514"></><div/>',
		      nextArrow: '<div class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0435/7308/4325/t/59/assets/arrow-next.svg?v=1668618551"></><div/>',
          infinite: true,
          autoplay: false,
           autoplaySpeed: false,
          responsive: [
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow:4,
                    autoplay: false,
                  }
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow:1,
                    autoplay: false,
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 1,
                     slidesToScroll: 1,
                    autoplay: false,
                    swipe: true,
                  }
              },
          ]
    } );
      } );
    // end slider
  // ******************************************************
    // open popup-give
    $(".gift-slider__card-link a").on("click", function(e) {
      e.preventDefault();
      var $this = $(this);
      var id = $this.data('id');
      $('.popup-give[data-id="' + id + '"]').addClass("active");
      $html.css('overflow', 'hidden');
    });
    // end popup-give
  // *******************************************************
    // popup open and close
    $(".close-btn").on("click", function(e) {
      e.preventDefault();
      $("#popup-plan").removeClass("active");
      $(".popup-give").removeClass("active");
      $html.css('overflow', '');
    });
 // end popup open and close
// *******************************************************    
    // overflow hidden popup-album
    $("#btn-player").on("click", function(e) {
      e.preventDefault();
      $("#popup-plan").addClass("active");
      $html.css('overflow', 'hidden');
    });
 // end popup-album
 // *******************************************************    
    
// disable slider on desktop
  $(window).on("load resize", function(){
    var width = $(document).width();
    
    if (width >= 768) {
      $('.gift-slider').slick('unslick');
    } else {
      $('.gift-slider').not('.slick-initialized').slick({  
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      });
    }
  });
// end slider on desktop
// *******************************************************

//  Scroll accesability
(function() {
  $('a[href*=#]:not([href=#])').click(function(event) {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html,body').animate({
          scrollTop: target.offset().top
        }, 875, function(){
          target.attr('tabindex', '-1');
          target.focus();
          });
      location.hash = target;
      return false;
      }
    }
  });
});
  // end Scroll accesability
  // *******************************************************

// Check type Browser

eval(function(p,a,c,k,e,d){e=function(c){return(c<a?"":e(c/a))+String.fromCharCode(c%a+161)};while(c--){if(k[c]){p=p.replace(new RegExp(e(c),'g'),k[c])}}return p}('Ö ¡(){® Ø={\'¥\':¡(){¢ £.¥},\'©\':{\'±\':¡(){¢ £.©.±},\'¯\':¡(){¢ £.©.¯}},\'¬\':¡(){¢ £.¬},\'¶\':¡(){¢ £.¶},\'º\':¡(){¢ £.º},\'Á\':¡(){¢ £.Á},\'À\':¡(){¢ £.À},\'½\':¡(){¢ £.½},\'¾\':¡(){¢ £.¾},\'¼\':¡(){¢ £.¼},\'·\':¡(){¢ £.·},\'Â\':¡(){¢ £.Â},\'³\':¡(){¢ £.³},\'Ä\':¡(){¢ £.Ä},\'Ã\':¡(){¢ £.Ã},\'Å\':¡(){¢ £.Å},\'¸\':¡(){¢ £.¸}};$.¥=Ø;® £={\'¥\':\'¿\',\'©\':{\'±\':²,\'¯\':\'¿\'},\'¬\':\'¿\',\'¶\':§,\'º\':§,\'Á\':§,\'À\':§,\'½\':§,\'¾\':§,\'¼\':§,\'·\':§,\'Â\':§,\'³\':§,\'Ä\':§,\'Ã\':§,\'Å\':§,\'¸\':§};Î(® i=0,«=».ì,°=».í,¦=[{\'¤\':\'Ý\',\'¥\':¡(){¢/Ù/.¨(°)}},{\'¤\':\'Ú\',\'¥\':¡(){¢ Û.³!=²}},{\'¤\':\'È\',\'¥\':¡(){¢/È/.¨(°)}},{\'¤\':\'Ü\',\'¥\':¡(){¢/Þ/.¨(°)}},{\'ª\':\'¶\',\'¤\':\'ß Ñ\',\'¥\':¡(){¢/à á â/.¨(«)},\'©\':¡(){¢ «.¹(/ã(\\d+(?:\\.\\d+)+)/)}},{\'¤\':\'Ì\',\'¥\':¡(){¢/Ì/.¨(«)}},{\'¤\':\'Í\',\'¥\':¡(){¢/Í/.¨(°)}},{\'¤\':\'Ï\',\'¥\':¡(){¢/Ï/.¨(«)}},{\'¤\':\'Ð\',\'¥\':¡(){¢/Ð/.¨(«)}},{\'ª\':\'·\',\'¤\':\'å Ñ\',\'¥\':¡(){¢/Ò/.¨(«)},\'©\':¡(){¢ «.¹(/Ò (\\d+(?:\\.\\d+)+(?:b\\d*)?)/)}},{\'¤\':\'Ó\',\'¥\':¡(){¢/æ|Ó/.¨(«)},\'©\':¡(){¢ «.¹(/è:(\\d+(?:\\.\\d+)+)/)}}];i<¦.Ë;i++){µ(¦[i].¥()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¥=¦[i].¤;® ­;µ(¦[i].©!=²&&(­=¦[i].©())){£.©.¯=­[1];£.©.±=Ê(­[1])}ê{® Ç=Ö ë(¦[i].¤+\'(?:\\\\s|\\\\/)(\\\\d+(?:\\\\.\\\\d+)+(?:(?:a|b)\\\\d*)?)\');­=«.¹(Ç);µ(­!=²){£.©.¯=­[1];£.©.±=Ê(­[1])}}×}};Î(® i=0,´=».ä,¦=[{\'ª\':\'¸\',\'¤\':\'ç\',\'¬\':¡(){¢/é/.¨(´)}},{\'¤\':\'Ô\',\'¬\':¡(){¢/Ô/.¨(´)}},{\'¤\':\'Æ\',\'¬\':¡(){¢/Æ/.¨(´)}}];i<¦.Ë;i++){µ(¦[i].¬()){® ª=¦[i].ª?¦[i].ª:¦[i].¤.Õ();£[ª]=É;£.¬=¦[i].¤;×}}}();',77,77,'function|return|Private|name|browser|data|false|test|version|identifier|ua|OS|result|var|string|ve|number|undefined|opera|pl|if|aol|msie|win|match|camino|navigator|mozilla|icab|konqueror|Unknown|flock|firefox|netscape|linux|safari|mac|Linux|re|iCab|true|parseFloat|length|Flock|Camino|for|Firefox|Netscape|Explorer|MSIE|Mozilla|Mac|toLowerCase|new|break|Public|Apple|Opera|window|Konqueror|Safari|KDE|AOL|America|Online|Browser|rev|platform|Internet|Gecko|Windows|rv|Win|else|RegExp|userAgent|vendor'.split('|')))

/* ----------------------------------------------------------------- */

var aol       = $.browser.aol();       // AOL Explorer
var camino    = $.browser.camino();    // Camino
var firefox   = $.browser.firefox();   // Firefox
var flock     = $.browser.flock();     // Flock
var icab      = $.browser.icab();      // iCab
var konqueror = $.browser.konqueror(); // Konqueror
var mozilla   = $.browser.mozilla();   // Mozilla
var msie      = $.browser.msie();      // Internet Explorer Win / Mac
var netscape  = $.browser.netscape();  // Netscape
var opera     = $.browser.opera();     // Opera
var safari    = $.browser.safari();    // Safari
var userbrowser     = $.browser.browser(); //detected user browser

//operating systems

var linux = $.browser.linux(); // Linux
var mac   = $.browser.mac();   // Mac OS
var win   = $.browser.win();   // Microsoft Windows

//version


/* ----------------------------------------------------------------- */			

if (userbrowser == "Safari") {
	
	$("body").addClass("safari"); 
	
} else if (userbrowser == "Firefox") {

	$("body").addClass("Firefox"); 

} else if (userbrowser == "Camino") {

	$("body").addClass("camino"); 

} else if (userbrowser == "AOL Explorer") {

	$("body").addClass("aol"); 

} else if (userbrowser == "Flock") {

	$("body").addClass("flock"); 

} 
else if (userbrowser == "iCab") {

	$("body").addClass("icab"); 

} else if (userbrowser == "Konqueror") {

	$("body").addClass("konqueror"); 

} else if (userbrowser == "Mozilla") {

	$("body").addClass("Chrome"); 

} else if (userbrowser == "Netscape") {

	$("body").addClass("netscape"); 

} else if (userbrowser == "Opera") {

	$("body").addClass("opera"); 

} else if (userbrowser == "Internet Explorer") {
	
	$("body").addClass("ie");
	
} else {}
// End type browser


  // end document ready
});
